import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

/*
 *
 * Sets the user's region as a Datadog RUM user property.
 * */
export function useSetRegion() {
  useEffect(() => {
    const regionTag = document.getElementById('__SEGWAY_REGION')
    if (regionTag) {
      try {
        const regionPayload = JSON.parse(regionTag.textContent)
        datadogRum.setGlobalContextProperty('region', regionPayload.region)
      } catch (e) {
        datadogRum.setGlobalContextProperty('region', 'unknown')
      }
    } else {
      datadogRum.setGlobalContextProperty('region', 'unknown')
    }
  }, [])
}
